import axios from 'axios';

/**
 * Fetch user's crypto wallets with balances
 */
export const getWalletsApi = async (): Promise<UserWalletInfo[]> => {
  const response = await axios.get<{ success: boolean; data: UserWalletInfo[] }>(
    '/api/crypto/wallets',
  );
  return response.data.data;
};
